import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
import DesignerTextField from './DesignerTextField';

import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import { checkForCode, androidBackButton } from './Utils';

import penClick from './Sounds/pen-click.wav';

class CreateGame extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;
    this.penClick = new Audio(penClick);

    this.state = {
      gameName: '',
      userStatus: 'Basic',

      RandomTeams: true,

      numberOfTeams: 2,
      wordsPerPerson: 2,
      numberOfPasses: 1,
      roundTime: 60,

      categories: [],
    };
  }

  componentDidMount() {
    androidBackButton(this.handleGoBackRoom);
    checkForCode(
      'GET',
      `/api/users/${this.props.cookies.get('code')}/nicknameAndType`,
      this.props,
      null
    ).then((data) => {
      this.setState({
        gameName: `играта на ${data.nickname}`,
        userStatus: data.type,
      });
    });
  }

  handleGoBackRoom = () => {
    this.penClick.play();
    this.props.navigate(`/`);
  };

  handleGoToInputTeamAndWords = async () => {
    let TeamNames = [
      'Blue Team',
      'Green Team',
      'Red Team',
      'Yellow Team',
      'Purple Team',
      'Orange Team',
      'Brown Team',
      //'White Team',
      'Grey Team',
      'Pink Team',
    ];

    let wifiID = 123456789;

    let body = JSON.stringify({
      wifiID: wifiID,
      Location: 'Sofia',
      sub: this.props.cookies.get('code'),
      userStatus: this.state.userStatus,
      gameName: this.state.gameName,
      wordsPerPerson: this.state.wordsPerPerson,
      RandomTeams: this.state.RandomTeams,
      numberOfTeams: this.state.numberOfTeams,
      TeamNames: TeamNames,
      roundTime: this.state.roundTime,
      numberOfPasses: this.state.numberOfPasses,
      categories: this.state.categories,
    });

    let data = await checkForCode('POST', `/api/rooms/`, this.props, body);
    this.penClick.play();
    this.props.navigate(`/TeamAndWords/${data.roomID}`);
  };

  addCategory = () => {
    if (this.state.categories.length < this.state.wordsPerPerson) {
      this.state.categories.push({ categoryName: '' });
      this.forceUpdate();
    }
  };

  removeCategory = (index) => {
    this.state.categories.splice(index, 1);

    this.forceUpdate();
  };

  handleCategoryInput = (event, index) => {
    // eslint-disable-next-line
    this.state.categories[index].categoryName = event.target.value;
    this.forceUpdate();
  };

  handleSelectChange = (categoryName, event) => {
    this.setState({ [categoryName]: event.target.value });
  };

  render() {
    return (
      <div className="Home">
        <h1 className="H1">Създай Игра</h1>

        <div className="arrowBackButtonDiv_CG">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBackRoom}></DesignerButton>
        </div>

        <div className="cssBanner">
          <hr className="cssBannerLine" />
          <div className="cssBannerText">Правила</div>
        </div>

        <label className="selectLabel">Име на играта</label>

        <DesignerTextField
          style={{ width: '90%' }}
          value={this.state.gameName}
          onChange={(event) => {
            this.setState({ gameName: event.target.value });
          }}
          minlength={4}
          placeholder={'Име на играта'}></DesignerTextField>

        <label className="selectLabel">Отбори {this.state.userStatus === "Premium" ? "" : "(купи премиум за да октлючиш)"}</label>
        <select
          disabled={this.state.userStatus !== 'Premium'}
          value={this.state.RandomTeams}
          onChange={(e) => {
            this.handleSelectChange('RandomTeams', e);
          }}
          className="selectDropdownMenu"
          id="Teams">
          <option value={true}>Случайни</option>
          {this.state.userStatus === 'Premium' && (
            <option value={false}>По Избор</option>
          )}
        </select>

        <label className="selectLabel">Брой Отбори {this.state.userStatus === "Premium" ? "" : "(купи премиум за да октлючиш)"}</label>
        <select
          disabled={this.state.userStatus !== 'Premium'}
          value={this.state.numberOfTeams}
          onChange={(e) => {
            this.handleSelectChange('numberOfTeams', e);
          }}
          className="selectDropdownMenu"
          id="Teams">
          {[...Array(this.state.userStatus === 'Premium' ? 9 : 1).keys()].map(
            (number) => {
              return (
                <option key={number} value={number + 2}>
                  {number + 2} Отбора
                </option>
              );
            }
          )}
        </select>

        <label className="selectLabel">Брой думи {this.state.userStatus === "Premium" ? "" : "(купи премиум за да октлючиш)"}</label>

        <select
          disabled={this.state.userStatus !== 'Premium'}
          value={this.state.wordsPerPerson}
          onChange={(e) => {
            this.handleSelectChange('wordsPerPerson', e);
          }}
          className="selectDropdownMenu"
          id="wordsPerPerson">
          {[...Array(this.state.userStatus === 'Premium' ? 19 : 1).keys()].map(
            (number) => {
              return (
                <option key={number} value={number + 2}>
                  {number + 2}
                </option>
              );
            }
          )}
        </select>

        <label className="selectLabel">Брой пасове {this.state.userStatus === "Premium" ? "" : "(купи премиум за да октлючиш)"}</label>

        <select
          disabled={this.state.userStatus !== 'Premium'}
          value={this.state.numberOfPasses}
          onChange={(e) => {
            this.handleSelectChange('numberOfPasses', e);
          }}
          className="selectDropdownMenu"
          id="numberOfPasses">
            {
              this.state.userStatus === 'Premium' ?
                [...Array(6).keys()].map(number => {
                  return <option key={number} value={number}>
                          {number}
                        </option>
                }) : <option key="1" value="1">1</option>
            }
        </select>

        <label className="selectLabel">Време за ход {this.state.userStatus === "Premium" ? "" : "(купи премиум за да октлючиш)"}</label>

        <select
          disabled={this.state.userStatus !== 'Premium'}
          value={this.state.roundTime}
          onChange={(e) => {
            this.handleSelectChange('roundTime', e);
          }}
          className="selectDropdownMenu"
          id="RoundTime">
            {this.state.userStatus === 'Premium' ? 
              [...Array(10).keys()].map(
                (number) => {
                  return (
                    <option key={number} value={15 * number + 15}>
                      {15 * number + 15} Секунди
                    </option>
                  );
                }
              ) : <option key="60" value="60">60 Секунди</option>
            }
        </select>

        {this.state.userStatus === 'Premium' && (
          <div className="cssBanner">
            <hr className="cssBannerLine" />
            <div className="cssBannerText">Категории</div>
          </div>
        )}

        {this.state.userStatus === 'Premium' &&
          this.state.categories.map((element, index) => (
            <div className="categoriesDiv" key={index}>
              <label className="selectLabel">
                write a category for word {index + 1}
              </label>
              <DesignerTextField
                style={{ width: '80%' }}
                value={element.categoryName}
                onChange={(event) => {
                  this.handleCategoryInput(event, index);
                }}></DesignerTextField>
              <IconButton
                aria-label="delete"
                sx={{ color: '#fe012f' }}
                onClick={() => {
                  this.removeCategory(index);
                }}>
                <DeleteIcon />
              </IconButton>
            </div>
          ))}

        {this.state.userStatus === 'Premium' && (
          <div className="addCategoryDiv">
            <DesignerButton
              //moga da sloja i display none
              //disabled={this.state.userStatus === 'Basic'}
              class="hollowButton"
              style={{ fontSize: '14px', height: '40px' }}
              onClick={this.addCategory}
              buttonText="+ Добави Категория"></DesignerButton>
          </div>
        )}

        <div className="createButtonOuterDiv">
          <div className="createButtonInnerDiv">
            <DesignerButton
              class="filledButton"
              disabled={this.state.gameName.length < 3 ? true : false}
              onClick={this.handleGoToInputTeamAndWords}
              buttonText="Създай"></DesignerButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withCookies(CreateGame);
